import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Vacation } from '../../types/team.types';
import { useAppQuery } from '../use-app-query.hook';

// Cross-tenant admin data (internal CapQuest vacations): intentionally not scoped to a single
// companyId — access is enforced server-side by AdminPanelGuard, not by the companies/:companyId
// path used by tenant-facing hooks.
export const useVacations = () => {
  const queryClient = useQueryClient();

  const invalidate = useCallback(
    () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_VACATIONS] }),
    [queryClient],
  );

  const { data, isLoading, isError } = useAppQuery<Vacation[]>({
    queryKey: [QueryKey.GET_VACATIONS],
    queryFn: () => ApiService.get({ endpoint: BackendRoute.TEAM_VACATIONS }),
  });

  return { vacations: data ?? [], isLoading, isError, invalidate };
};
